import TriggerExecutionsChart from "./TriggerExecutionsChart";

export default TriggerExecutionsChart